module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1002-8d19d8d0878a96b99a003b2959fe5d7b.png";